export default __webpack_public_path__ + "static/appdownloadbanner-cd9196c3e5fb13d7cb6a58660d8ef96f.png";